const TopNav = {
    bindEvents: () => {
        let navBody = document.getElementsByClassName('main-app');
        if (navBody) {
            TopNav.init(navBody[0]);
        }
    },

    init: (navWrapper) => {
        // bind event for burger menu-toggle
        const burgerMenu = document.getElementsByClassName('overlay-menu');
        for (let i = 0; i < burgerMenu.length; i++) {
            burgerMenu[i].addEventListener('click', (e) => {
                e.preventDefault();
                navWrapper.classList.toggle('active-menu');
            });


        }

        // Sub menu toggle view
        const subLinks = document.getElementsByClassName('has-sub-icon');
        for (let i = 0; i < subLinks.length; i++) {
            subLinks[i].addEventListener('click', (e) => {
                e.preventDefault();
                subLinks[i].parentElement.parentElement.classList.toggle('active');
            })
        }

        // SEARCH BUTTON - toggle
        const searchWrapper = document.getElementsByClassName('site-search')[0];
        const searchToggle = document.getElementsByClassName('btn-search-toggle');
        for (let i = 0; i < searchToggle.length; i++) {
            searchToggle[i].addEventListener('click', (e) => {
                searchWrapper.classList.toggle('active');
                if (searchWrapper.classList.contains('active')) {
                    searchWrapper.getElementsByClassName('form-control')[0].focus();
                }
            });
        }

        // CLOSE menu-toggle
        let overlayOutside = document.querySelector('.sib-overlay-outside--nav');
        overlayOutside.addEventListener('click', (e) => {
            e.preventDefault();

            navWrapper.classList.remove('active-menu');
        });
    },
};

module.exports = TopNav;



// WEBPACK FOOTER //
// ./src/js/partials/topnav.js